type Size = 'sm' | 'md' | 'lg' | 'xl';
type Color = 'gray' | 'blue' | 'green' | 'purple' | 'pink';

interface TypingAnimationBounceProps {
  size?: Size;
  color?: Color;
}

const sizeClasses: Record<Size, string> = {
  sm: 'w-1 h-1',
  md: 'w-2 h-2',
  lg: 'w-3 h-3',
  xl: 'w-4 h-4'
};

const colorClasses: Record<Color, string> = {
  gray: 'bg-gray-500',
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  purple: 'bg-purple-500',
  pink: 'bg-pink-500'
};

const TypingAnimationBounce = ({ size = 'md', color = 'gray' }: TypingAnimationBounceProps) => {
  const dotSize = sizeClasses[size];
  const dotColor = colorClasses[color];

  return (
    <>
      <div className="flex items-center space-x-1">
        <div
          className={`${dotSize} ${dotColor} rounded-full animate-sequential-bounce`}
          style={{ animationDelay: '0ms' }}
        ></div>
        <div
          className={`${dotSize} ${dotColor} rounded-full animate-sequential-bounce`}
          style={{ animationDelay: '200ms' }}
        ></div>
        <div
          className={`${dotSize} ${dotColor} rounded-full animate-sequential-bounce`}
          style={{ animationDelay: '400ms' }}
        ></div>
      </div>

      <style>{`
        @keyframes sequential-bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }
        
        .animate-sequential-bounce {
          animation: sequential-bounce 1.5s infinite ease-in-out;
        }
      `}</style>
    </>
  );
};

export default TypingAnimationBounce;